// extracted by mini-css-extract-plugin
export var btn = "burger-button-module--btn--gB7M1";
export var open = "burger-button-module--open--3TjTU";